import PropTypes from 'prop-types';

export const propTypes = {
  mode: PropTypes.oneOf(['inline', 'dropdown', 'auto']),
  isMobileView: PropTypes.bool,
  forceDropdown: PropTypes.bool,
  onStart: PropTypes.func,
  onFavorite: PropTypes.func,
  onTaskTraces: PropTypes.func,
  onConfig: PropTypes.func,
  onProcessConfig: PropTypes.func,
  onDetail: PropTypes.func,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  onBulkDownload: PropTypes.func,
  onStartModeClick: PropTypes.func,
  isFavorite: PropTypes.bool,
  disabled: PropTypes.bool,
  startMode: PropTypes.number,
  isBulkRequestCreationEnabled: PropTypes.bool,
  BulkUploadComponent: PropTypes.node,
  userRole: PropTypes.shape({
    isUserRole: PropTypes.bool,
    isSuperAdmin: PropTypes.bool,
    canManage: PropTypes.bool,
  }),
  formatMessage: PropTypes.func,
  all: PropTypes.bool,
  viewMode: PropTypes.string,
  customItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      type: PropTypes.string,
    }),
  ),
  actionOrder: PropTypes.shape({
    primary: PropTypes.arrayOf(PropTypes.string),
    secondary: PropTypes.arrayOf(PropTypes.string),
  }),
};

export const defaultProps = {
  mode: 'auto',
  isMobileView: false,
};
